import ResourceService from "./resource.service";

class HajjSeasonYearService extends ResourceService {
  static get resource() {
    return "hajj-season-years";
  }
}

export default HajjSeasonYearService;
